import { render, staticRenderFns } from "./ProductsVariation.vue?vue&type=template&id=14833b98&"
import script from "./ProductsVariation.vue?vue&type=script&lang=js&"
export * from "./ProductsVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports